import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/ui/pages/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: HomeView,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
